import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function MicroneedlingHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1657">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/dYjWwN1rrZHQJmgUFmRGBD/Microneedling-BeClinical.jpg)'
    }} data-id="element-1658" />
      <div className="absolute inset-0 bg-black/50" data-id="element-1659" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1660">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1661">
          <div className="mb-6" data-id="element-1662">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1663">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1664">
                Treatments
              </a>{' '}
              / Skin
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1665">
            Be LOVED
          </span>

          <h1 className="text-[36px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1666">
            MICRONEEDLING
          </h1>

          <div className="space-y-6" data-id="element-1667">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1668">
              Over the years, microneedling has captured the attention of beauty
              enthusiasts and skincare professionals alike, offering a proven
              way to enhance skin texture, reduce fine lines and stimulate the
              skin's natural collagen production. Microneedling at Be CLINICAL
              utilizes the FDA-cleared SkinPen device.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1669">
              Designed to stimulate the body's natural healing process, this
              non-invasive procedure targets specific skin concerns, unveiling a
              renewed and radiant version of yourself.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1670">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}